import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { BiCodeAlt } from "react-icons/bi";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";
import Menu from "./Menu";
import { AiOutlineMenu } from "react-icons/ai";
import Contact from "./Contact";
function Navbar({ section1, services, about }) {
  const location = useLocation();
  const navigate = useNavigate();
  const [bar, barInView] = useInView({
    triggerOnce: true, // Animation triggered only once
    threshold: 0.5, // Adjust the threshold as needed
  });
  const animationVariants = {
    hidden: {
      opacity: 0,
      y: -20,
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 1,
        ease: "easeInOut",
      },
    },
  };
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [clicked, setClicked] = useState(false);
  const handleOpen = () => {
    setClicked(true);
  };
  const handleClose = () => {
    setClicked(false);
  };
  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <>
      <motion.div
        className="navbar"
        ref={bar}
        initial="hidden"
        animate={barInView ? "visible" : "hidden"}
        variants={animationVariants}
      >
        <div
          className="logo"
          onClick={() => {
            navigate(`/`);
          }}
        >
          <BiCodeAlt size={25} color="#0ca4e7" /> Ala Gtari
        </div>
        <div className="nav-items">
          <div
            className="nav-item"
            onClick={() => {
              if (location.pathname == "/") {
                section1.current.scrollIntoView({ behavior: "smooth" });
              } else {
                navigate(`/`);
              }
            }}
          >
            Home
          </div>
          <div
            className="nav-item"
            onClick={() => {
              if (location.pathname == "/") {
                services.current.scrollIntoView({ behavior: "smooth" });
              } else {
                navigate(`/`);
              }
            }}
          >
            Services
          </div>
          <div
            className="nav-item"
            onClick={() => {
              if (location.pathname == "/") {
                about.current.scrollIntoView({ behavior: "smooth" });
              } else {
                navigate(`/`);
              }
            }}
          >
            About
          </div>
          <div
            className="nav-item"
            onClick={() => {
              if (location.pathname == "/") {
                navigate(`/projects`);
              }
            }}
          >
            Projects
          </div>
        </div>
        {windowWidth < 500 && <AiOutlineMenu size={25} onClick={handleOpen} />}
        {clicked && (
          <Menu
            section1={section1}
            services={services}
            about={about}
            close={handleClose}
          />
        )}
      </motion.div>
      {windowWidth > 500 && <Contact />}
    </>
  );
}

export default Navbar;
